__turbopack_context__.v({
  "banner": "styles-module__M1W7-G__banner",
});
